/**
 * Renders an generic text input field
 * @returns {JSX.Element} The basic text input.
 * @param {any} props given by callerDefaultValue
 */

import { getTodaysDate, toDateFormat, toDateTimeFormat, roundDateTo15Minutes, changeTimeOfDateRounding } from '../../../Helpers/dateHelper';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import LocalStorage from 'Helpers/MFXLocalStorage';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const InputElement = props => {
    //DESIGNDATA -> DESIGNER
    //VALUE -> CUSTOMER
    let inputClasses = '';
    let inputID = 'input-' + props.designData.Key + '-' + props.uniqueIndex;
    let inputName = !isNaN(props.designData.Label) ? props.designData.Label : window.Dictionary.getTranslation(props.designData.Label);
    let inputValue = '';
    let multiple = props.designData.Type === 'email' ? true : false;
    if (props.ignoreDefaultValue) {
        props.designData.DefaultValue = null;
    }
    if (props.designData.Type.toLowerCase() === 'tel') {
        inputValue = props.customerData ? props.customerData : props.designData?.DefaultValue ? props.designData?.DefaultValue : '';
    } else if (props.designData.Type.toLowerCase() === 'text') {
        inputValue = props.customerData ? props.customerData : props.designData?.DefaultValue ? props.designData?.DefaultValue : '';
    } else if (props.designData.Type.toLowerCase() === 'email') {
        inputValue = props.customerData ? props.customerData.replace(';', ',') : props.designData?.DefaultValue ? props.designData?.DefaultValue.replace(';', ',') : '';
    } else if (props.designData.Type.toLowerCase() === 'time') {
        inputValue = props.customerData && new Date(props.customerData) instanceof Date ? new Date(props.customerData) : props.designData?.DefaultValue && new Date(props.designData?.DefaultValue) instanceof Date ? new Date(props.designData?.DefaultValue) : '';
    } else if (props.designData?.DefaultValue === 'today') {
        inputValue = getTodaysDate(0, props.designData?.Type);
    } else {
        inputValue =
            props.designData.Type.toLowerCase() === 'number'
                ? props.customerData || props.designData?.DefaultValue
                    ? Math.round((props.customerData ?? props.designData?.DefaultValue ?? 0) * 100) / 100
                    : ''
                : props.designData.Type.toLowerCase() === 'datetime-local'
                ? toDateTimeFormat(props.customerData ?? props.designData?.DefaultValue)
                : props.designData.Type.toLowerCase() === 'date'
                ? toDateFormat(props.customerData ?? props.designData?.DefaultValue)
                : props.customerData ?? props.designData?.DefaultValue;
    }

    let readonly = props.designData.ReadOnly && !props.designData.WriteGroups?.includes(LocalStorage.getData('UserRole')) ? true : false;

    const inputChangeHandler = event => {
        if (event === null) {
            props.onChangeHandler({ newValue: '', type: props.uniqueIndex, designData: props.designData });
            inputValue = '';
            return;
        }
        var newValue = event.target ? event.target.value : event;
        if (!props.isFilter) {
            switch (props.designData.Type.toLowerCase()) {
                case 'time':
                    //var fullDate = props.customerData || props.designData?.DefaultValue || new Date();
                    newValue = roundDateTo15Minutes(event); //changeTimeOfDate(fullDate, newValue);
                    break;
                case 'date':
                    // Only convert to Date if input is a valid date string (YYYY-MM-DD) and year >= 1900
                    if (typeof newValue === 'string' && newValue.length === 10 && !isNaN(Date.parse(newValue))) {
                        const year = parseInt(newValue.substring(0, 4), 10);
                        console.log(year);
                        if (year >= 1900) {
                            newValue = new Date(newValue);
                            console.log(newValue);
                        }
                    }
                    break;
                case 'number':
                    newValue = parseFloat(newValue) || null;
                    break;
                default:
                    break;
            }
        }
        console.log(newValue);
        props.onChangeHandler({ newValue: newValue, type: props.uniqueIndex, designData: props.designData });
        inputValue = newValue;
    };
    function onBlur(event) {
        var newValue = event.target ? event.target.value : event;
        if (!props.isFilter) {
            switch (props.designData.Type.toLowerCase()) {
                case 'time':
                    var fullDate = props.customerData || props.designData?.DefaultValue || new Date();
                    newValue = changeTimeOfDateRounding(fullDate, newValue);
                    break;
                case 'date':
                    // Only convert to Date if input is a valid date string (YYYY-MM-DD) and year >= 1900
                    if (typeof newValue === 'string' && newValue.length === 10 && !isNaN(Date.parse(newValue))) {
                        const year = parseInt(newValue.substring(0, 4), 10);
                        console.log(year);
                        if (year >= 1900) {
                            newValue = new Date(newValue);
                            console.log(newValue);
                        }
                    }
                    break;
                default:
                    break;
            }
        }
        console.log(newValue);
        props.onChangeHandler({ newValue: newValue, type: props.uniqueIndex, designData: props.designData });
        inputValue = newValue;
    }

    function roundToNearest15Minutes(hours, minutes) {
        const roundedMinutes = Math.round(minutes / 15) * 15;
        if (roundedMinutes === 60) {
            return {
                hours: (hours + 1) % 24,
                minutes: 0,
            };
        }
        return {
            hours,
            minutes: roundedMinutes,
        };
    }

    if (props.designData.Key === 'Priority' || props.designData.Key === 'Data-Priority') {
        inputClasses += 'priority_' + inputValue + ' ';

        switch (inputValue) {
            case '':
            case 0:
                inputValue = window.Dictionary.getTranslation(1408);
                break;
            case 1:
                inputValue = window.Dictionary.getTranslation(1409);
                break;
            case 2:
                inputValue = window.Dictionary.getTranslation(1410);
                break;
            case 3:
                inputValue = window.Dictionary.getTranslation(4955);
                break;
            default:
                break;
        }
        props.designData.Type = 'text';
    }

    function clearInput(e) {
        props.onChangeHandler({ newValue: '', type: props.uniqueIndex, designData: props.designData });
    }

    const showPwd = event => {
        let curElement = event.target;
        if (event.target.tagName.toLowerCase() === 'i') curElement = event.target.parentNode;

        if (curElement.previousElementSibling.type === 'password') curElement.previousElementSibling.type = 'text';
        else curElement.previousElementSibling.type = 'password';
    };
    const handleKeyDown = event => {
        if (event.key === 'Enter') props.onEnterPressed();
    };

    function onChangeRawHandler(event) {
        var val = event.target.value;
        let digitsOnly = val.replace(/:/g, '');

        // Check if original input already had a colon
        const colonExists = val.includes(':');

        // If user tries to add colon but colon already exists, ignore the input's extra colon by removing it
        if ((val.match(/:/g) || []).length > 1) {
            //
        } else if (colonExists && digitsOnly.length <= 2 && val.indexOf(':') === 1) {
            // User typed colon right after first digit like "1:"
            // Add leading zero to make "01:"
            digitsOnly = digitsOnly.padStart(2, '0');
        }

        // Insert colon right after second digit (or after 2 digits padded)
        if (digitsOnly.length >= 2) {
            val = digitsOnly.slice(0, 2) + ':' + digitsOnly.slice(2);
        } else {
            val = digitsOnly;
        }

        if (event.nativeEvent.inputType !== 'deleteContentBackward' && event.nativeEvent.inputType !== 'deleteContentForward') event.target.value = val;

        const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;
        const match = TIME_REGEX.exec(val);
        if (!match) return;
        let hours = parseInt(match[1], 10);
        let minutes = parseInt(match[2], 10);
        ({ hours, minutes } = roundToNearest15Minutes(hours, minutes));

        const date = inputValue || new Date();
        date.setHours(hours, minutes, 0, 0);
        props.onChangeHandler({ newValue: date, type: props.uniqueIndex, designData: props.designData });
        inputValue = date;
        event.target.value = String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
    }

    return (
        <div className={`mfx-input-element mfx-input-${props.designData.Type} ${inputClasses}`}>
            {!props.noLabel && props.designData.Label && (
                <label htmlFor={inputName} style={{ color: props.disableMode || readonly ? 'var(--gray)' : 'var(--fontColor)' }}>
                    {!isNaN(props.designData.Label) ? window.Dictionary.getTranslation(props.designData.Label) : props.designData.Label}
                    {props.designData.Required && '*'}
                </label>
            )}
            <div className="mfx-input-element-wrapper">
                {(props.designData.Key === 'Process-SignalCode' || props.designData.Key === 'SignalCode') && <span className={'signalcode' + (inputValue !== null && inputValue !== undefined ? '_' + inputValue : '')}></span>}

                {props.designData.Type !== 'tel' && props.designData.Type !== 'time' && (
                    <input
                        style={props.fitContent ? (readonly ? { width: 6 + (inputValue?.toString().length ?? 0) + 'ch' } : { minWidth: 6 + (inputValue?.toString().length > 40 ? 40 : inputValue?.toString().length) + 'ch' }) : {}}
                        id={inputID}
                        type={props.designData.Type}
                        value={inputValue}
                        placeholder={props.designData.Placeholder}
                        name={props.designData.Key}
                        disabled={Boolean(props.disableMode)}
                        min={props.designData.Min}
                        max={props.designData.Max}
                        readOnly={readonly}
                        data-type={props.designData.DataType}
                        required={props.designData.Required}
                        onChange={inputChangeHandler}
                        onBlur={onBlur}
                        onKeyDown={handleKeyDown}
                        multiple={multiple}
                    />
                )}

                {props.designData.Type === 'tel' && (
                    <>
                        <PhoneInput
                            country={LocalStorage.getData('UserData')?.CountryIso?.toLowerCase() || 'at'}
                            placeholder="Telefonnummer hinzufügen"
                            inputProps={{ id: inputID, maxLength: 20 }}
                            masks={{ de: '.... ...........' }}
                            value={inputValue}
                            disabled={Boolean(props.disableMode)}
                            onChange={inputChangeHandler}
                        />
                        <i className="icon-phone"></i>
                    </>
                )}
                {props.designData.Type === 'email' && <i className="icon-mail"></i>}
                {/*props.designData.Type === 'date' && <i className='fas fa-calendar'></i>*/}
                {/*props.designData.Type === 'datetime-local' && <i className='fas fa-calendar'></i>*/}
                {props.designData.Type === 'password' && (
                    <button type="button" className="no-styling" onMouseDown={showPwd}>
                        <i className="fas fa-eye"></i>
                    </button>
                )}
                {props.withDelete === true && (
                    <button type="button" className="no-styling" onMouseDown={clearInput}>
                        <i className="fas fa-close"></i>
                    </button>
                )}
                {props.designData.Type === 'range' && <output>{inputValue}</output>}
                {props.designData.Type === 'time' && (
                    <DatePicker
                        id={inputID}
                        selected={inputValue}
                        onChange={newTime => {
                            inputChangeHandler(newTime);
                        }}
                        onChangeRaw={newTime => onChangeRawHandler(newTime)}
                        showTimeSelect
                        showTimeSelectOnly
                        disabled={Boolean(props.disableMode)}
                        timeIntervals={15}
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        className="react-datepicker__time-input"
                        autoComplete="off"
                    />
                )}
            </div>
        </div>
    );
};

export default InputElement;
